export const DEVICE_RESERVATION_AND_STOCK_CHANNEL = '06'
